import { StoreActionType as Type } from "../../types";

const initialState: any = {
  isMenuOpen: localStorage.getItem("isMenuOpen") === "true" ? true : false
};

export const menuReducer: any = (state: any = initialState, action: any) => {
  switch (action?.type) {
    case Type.SET_MENU_OPEN:
      localStorage.setItem("isMenuOpen", action?.payload?.isMenuOpen.toString());
      return {
        ...state,
        isMenuOpen: action?.payload?.isMenuOpen,
      };

    default:
      return state;
  }
};
